import { isBrowser } from "./client-utils.ts";

function stripStyles(element: HTMLElement): HTMLElement {
  const clone = element.cloneNode(true) as HTMLElement;
  clone.querySelectorAll('*').forEach((el: Element) => {
    if (el.tagName.toLowerCase() === 'b' || el.tagName.toLowerCase() === 'strong') return;
    if (el instanceof HTMLElement && el.classList.contains('bold')) {
      const strong = document.createElement('strong');
      strong.innerHTML = el.innerHTML;
      el.parentNode?.replaceChild(strong, el);
      return;
    }
    if (el instanceof HTMLElement && el.style.length > 0) {
      const styles = getComputedStyle(el);
      const allowedStyles: string[] = [];
      if (styles.fontWeight === 'bold' || styles.fontWeight >= '700') {
        allowedStyles.push(`font-weight: ${styles.fontWeight}`);
      }
      el.removeAttribute('style');
      if (allowedStyles.length > 0) {
        el.setAttribute('style', allowedStyles.join('; '));
      }
    }
  });
  return clone;
}


if (isBrowser) {
  document.addEventListener('copy', async (event: ClipboardEvent) => {
    if (typeof ClipboardItem === 'undefined') return;
    event.preventDefault();
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return;
    const range = selection.getRangeAt(0);
    const div = document.createElement('div');
    div.appendChild(range.cloneContents());
    const cleanContent = stripStyles(div);
    const htmlBlob = new Blob([cleanContent.innerHTML], { type: 'text/html' });
    const textBlob = new Blob([div.textContent || ''], { type: 'text/plain' });
    const clipboardItem = new ClipboardItem({
      'text/html': htmlBlob,
      'text/plain': textBlob,
    });
    await navigator.clipboard.write([clipboardItem]).catch((err) => console.error('Clipboard write failed:', err));
  });
}